import StateIcon from './component'

export default StateIcon
